var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.926 5.09886C15.1028 5.32307 15.209 5.61809 15.209 5.92491C15.209 6.23173 15.1028 6.52675 14.926 6.75097C13.7704 8.14346 11.1644 10.8576 8.09858 10.8576C5.03275 10.8576 2.42679 8.14346 1.283 6.75097C1.10612 6.52675 1 6.23173 1 5.92491C1 5.61809 1.10612 5.32307 1.283 5.09886C2.42679 3.70637 5.04454 0.992188 8.09858 0.992188C11.1526 0.992188 13.7704 3.70637 14.926 5.09886Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.09559 8.11938C9.31013 8.11938 10.2888 7.13992 10.2888 5.92444C10.2888 4.70896 9.31013 3.72949 8.09559 3.72949C6.88105 3.72949 5.90234 4.70896 5.90234 5.92444C5.90234 7.13992 6.88105 8.11938 8.09559 8.11938Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEye;